import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { reactI18nextModule } from "react-i18next";

import translationEN from './Comman/locales/en/translation.json';
import translationSV from './Comman/locales/sv/translation.json';

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  sv: {
    translation: translationSV
  }
};
var lang;
if(sessionStorage.getItem('Language')){
    lang = sessionStorage.getItem('Language');  
}
else{
  lang = 'en';
}
i18n
  .use(detector)
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    resources,
    lng: lang,
    fallbackLng: lang, // use en if detected lng is not available

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;